import { useSelector, useDispatch } from "react-redux";
import { useDropzone } from "react-dropzone";
// ------------------------------------------------------
import CheckinProgress from "Screens/Files/CheckinProgress";
// ------------------------------------------------------
import { upload } from "System/system";
import { startUnzipping } from "Redux/conversions/actions";
// ------------------------------------------------------

const Upload = () => {
  const dispatch = useDispatch();
  const { id } = useSelector((state) => state.project);

  const onDrop = async (acceptedFiles) => {
    dispatch({
      type: "SHOW_HIDE_CONVERTERS",
      showConverters: true,
    });
    const formData = new FormData();
    formData.append("filetoupload", acceptedFiles[0]);
    formData.append("projectid", id);
    const result = await upload(formData, (pointer) => {
      dispatch({
        type: "SET_CHECKIN_PROGRESS",
        pointer,
        ext: "upload",
      });
    });
    const {
      data: { originalFolder, tag },
    } = result;
    await dispatch(startUnzipping(originalFolder, tag));
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div>
      <CheckinProgress />
      <div className="box">
        <div className="title is-6">Drop Zip Files Here For Upload</div>
        <div className="drop-zone-wrapper">
          <div {...getRootProps()} className="drop-zone">
            <input {...getInputProps()} />
            <i className="fa-duotone fa-file-archive zipper" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Upload;
